import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWallRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-wall-right, align right"} maskId="square-filled-radius-0-stroke-1-IconArrowWallRight"><path fillRule="evenodd" clipRule="evenodd" d="M22 4V20H21V4H22ZM12.75 6.54289L18.2071 12L12.75 17.4571L12.0429 16.75L16.2929 12.5H2V11.5H16.2929L12.0429 7.25L12.75 6.54289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowWallRight;
